import React from "react";

export default function Logo() {
  return <img src="/images/logo.svg" alt="CampusIQ Logo" />;
}